<template>
  <div>
    <v-btn color="primary-dark" variant="elevated" elevation="0" density="compact" @click.stop="drawer = !drawer">
      <v-icon color="white" class="mr-1" icon="mdi-account"></v-icon>Mon compte</v-btn>

    <v-navigation-drawer v-model="drawer" temporary>
      <!-- Compte public -->
      <div class="d-flex align-center flex-column gap mt-3 mx-2">
        <v-icon size="x-large" icon="mdi-account" color="primary-dark"></v-icon>
        <div class="font-weight-bold">Mon compte Sportips</div>
        <div class="text-subtitle-1 text-center" style="word-break: break-all">
          <span v-if="mainStore.authUser.isLogged">{{ mainStore.authUser.userData.mail }}</span>
          <span v-else>Non connecté</span>
        </div>
      </div>
      <v-divider style="margin: 10px 0 !important"></v-divider>
      <div class="d-flex flex-column gap mx-2" v-if="mainStore.authUser.isLogged">
        <router-link :to="{ name: 'Administration' }" v-if="mainStore.authUser.isSportips"><v-btn block color="darkblue"
            prepend-icon="mdi-view-dashboard" class="text-left">Accèder à
            l'administration</v-btn></router-link>
        <router-link :to="{ name: 'Home', query: { admin_token: token } }" v-if="mainStore.authUser.isSportips"><v-btn
            block color="darkblue" prepend-icon="mdi-lock" class="text-left">Accèder au module
            ouvert</v-btn></router-link>
        <router-link :to="{ name: 'FicheCoureur' }"><v-btn block color="primary-dark" prepend-icon="mdi-account"
            class="text-left">Accèder à ma fiche</v-btn></router-link>
        <v-btn prepend-icon="mdi-logout" color="dark-red" @click="mainStore.authUser.logout()">Déconnexion</v-btn>
      </div>
      <div class="d-flex flex-column gap mx-2" v-else>
        <v-btn block color="primary-dark" prepend-icon="mdi-account" class="text-left" @click="show_login_form()">Se
          connecter</v-btn>
      </div>
      <!-- Compte Admin -->

      <div v-if="mainStore.authAdmin.isLogged">
        <v-divider style="margin: 10px 0 !important"></v-divider>
        <div class="d-flex align-center flex-column gap mt-3 mx-2">
          <v-icon size="x-large" icon="mdi-view-dashboard" color="primary-dark"></v-icon>
          <div class="font-weight-bold">Mon compte Administrateur</div>
          <div class="text-subtitle-1 text-center" style="word-break: break-all">
            {{ mainStore.authAdmin.adminData.username }}
          </div>
        </div>
        <v-divider style="margin: 10px 0 !important"></v-divider>
        <div class="d-flex flex-column gap mx-2">
          <router-link :to="{ name: 'Administration' }"><v-btn block color="darkblue" prepend-icon="mdi-view-dashboard"
              class="text-left">Accèder à l'administration</v-btn></router-link>

          <v-btn prepend-icon="mdi-logout" color="dark-red" @click="mainStore.authAdmin.logout()">Déconnexion
          </v-btn>
        </div>
      </div>
    </v-navigation-drawer>
    <v-dialog v-model="showDialog" width="500" max-width="100%" scroll-strategy="none">
      <v-card>
        <v-card-text>
          <LoginForm></LoginForm>
        </v-card-text>
        <v-card-actions>
          <v-btn color="primary" block @click="showDialog = false">Fermer</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { useMainStore } from "@/stores/mainStore";
import { mapStores } from "pinia";


import LoginForm from "../Authentification/LoginForm.vue";
export default {
  components: { LoginForm },
  watch: {
    "mainStore.authUser.isLogged": function () {
      this.showDialog = false;
    },
  },
  computed: {
    ...mapStores(useMainStore),
  },
  methods: {
    show_login_form() {
      this.showDialog = true;
    },
  },

  data() {
    return {
      showDialog: false,
      drawer: null,
      token: "",
    };
  },
  async mounted() {
    this.token = await this.mainStore.authUser.loadAdminToken();
  },
};
</script>

<style lang="scss" scoped></style>